<template>
  <div class="row">
    <div class="col-3 p-0 bg-white border-right">
      <div class="list-group list-group-flush border-bottom">
        <router-link to="/settings/email-templates" class="list-group-item list-group-item-action">E-mail Templates</router-link>
      </div>
    </div>
    <div class="col-9 p-0 bg-light detail">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>


export default {
  name: 'settings',
  methods: {

  }
}
</script>

<style scoped>
.detail {
  height: calc(100vh - 48px);
  overflow-y: auto;
}
</style>